import { useCallback, useState } from 'react';
/**
 * use one-level merged object state stored in localStorage
 */
export function usePersistState(localStorageKey, initialState) {
    const [state, setState] = useState(() => {
        try {
            const state = {
                ...initialState,
                ...JSON.parse(window.localStorage.getItem(localStorageKey) ?? '{}'),
            };
            window.localStorage.setItem(localStorageKey, JSON.stringify(state));
            return state;
        }
        catch (err) {
            window.localStorage.setItem(localStorageKey, JSON.stringify(initialState));
            return initialState;
        }
    });
    return [
        state,
        useCallback((newState) => {
            const state = {
                ...JSON.parse(window.localStorage.getItem(localStorageKey) ?? '{}'),
                ...newState,
            };
            window.localStorage.setItem(localStorageKey, JSON.stringify(state));
            setState(state);
            return state;
        }, [localStorageKey]),
    ];
}
//# sourceMappingURL=usePersistState.js.map